import React from "react";
import { Reveal } from "@/components/Reveal";
import { PILLARS, IMAGES } from "@/data/content";

export const WhySection = () => {
  return (
    <section id="why" className="pt-16 md:pt-20 pb-16 md:pb-20 bg-warmwhite" data-testid="why-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="overline text-champagne mb-6">Why The Standard</p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08] text-charcoal">
                A different category of home care.
              </h2>
              <p className="mt-8 text-charcoal/70 leading-relaxed max-w-md">
                We don't simply clean. We restore order, protect beautiful homes, and give busy homeowners back their time — with the quiet precision of a premium brand.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="img-frame group">
                <img src={IMAGES.about} alt="Sunlit luxury living room" className="w-full aspect-[4/3] object-cover" />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-3 gap-px bg-stone/60 border border-stone/60">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.12} className="bg-warmwhite">
              <div className="p-10 md:p-12 h-full" data-testid={`pillar-${i}`}>
                <span className="font-serif text-champagne text-3xl">0{i + 1}</span>
                <h3 className="font-serif text-2xl md:text-3xl text-charcoal mt-6 mb-4 font-normal">{p.title}</h3>
                <p className="text-charcoal/65 leading-relaxed text-[15px]">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
